import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'page-header-child',
  standalone: false,
  templateUrl: './page-header-child.component.html',
  styleUrls: ['./page-header-child.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderChildComponent {
  private _location = inject(Location);

  title = input<string | undefined>(undefined);

  goBack(): void {
    this._location.back();
  }
}
